<template>
  <div class="mb-5" style="background-color: var(--color-light-light-gray); padding: 20px">
    <h4 class="h5 fw-bold mb-3">
      {{
        $t(
          `project.previewAndReport.reportTypes.${reportType}.installation.title`
        )
      }}
    </h4>
    <div class="row">
      <div class="col-12">
        <p class="mb-3">
          {{
            $t(
              `project.previewAndReport.reportTypes.${reportType}.installation.description`
            )
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "InstallationSection",
  props: {
    reportType: {
      type: String,
      required: true,
    },
  },
});
</script>
